import { Grid, IconButton, MenuItem, Paper, Select, Tooltip } from '@material-ui/core';
import React, { useEffect } from 'react';
import CreateGradientString from '../util/CreateGradientString';
import AnimationSlider from './AnimationSlider';

import AutoRotateIcon from '@material-ui/icons/Rotate90DegreesCcw';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import { Pause as PauseIcon, PlayArrow } from '@material-ui/icons';
import { modelCardProps, ModelDetail } from '../types/modelcard';
import ModelViewerSetup from '../util/modelViewerInit'

export default function SimpleViewer(props: { model: ModelDetail;  className?: string; elevation?: number; }) {

    const modelViewer = React.useRef<any>();
    useEffect(() => ModelViewerSetup(), []);
    const viewer = React.useRef<HTMLDivElement>();

    useEffect(() => {
        //Init model viewer - called each page load
        const mvInit = () => {
            //set orbit
            const mv = modelViewer.current;
            if (!mv) return;

            mv.cameraOrbit = `${props.model.Orbit.theta}rad ${props.model.Orbit.phi}rad ${props.model.Orbit.radius}m`;
            mv.resetTurntableRotation(0);
        }
        if (modelViewer.current) modelViewer.current.addEventListener("load", mvInit);

        return () => {
            if (modelViewer.current) modelViewer.current.removeEventListener("load", mvInit);
        }
    }, [props.model]);

    const bgGradient = CreateGradientString(props.model.Background.one, props.model.Background.two, props.model.Background.type);

    return (
        <Grid item className={props.className}>
            <Paper elevation={props.elevation ?? 0} className={'w-full h-full relative'} style={{ background: bgGradient, borderRadius: '0 0 4px 0' }} ref={viewer}>
                {/* @ts-ignore */}
                <model-viewer
                    ref={modelViewer}
                    oncontextmenu="return false;"
                    id="mainModel"
                    environment-image="/static/HDR/BG.hdr"
                    class={'w-full h-full'}
                    // class={`noMenu`}
                    src={`https://static.poly.pizza/${props.model.ResourceID}.glb.br`}
                    alt={props.model.Title}
                    auto-rotate
                    shadow-intensity="1"
                    interaction-prompt="none"
                    auto-rotate-delay="0"
                    loading="eager"
                    onerror={(error) => console.error(error)}
                    // autoplay={props.model.Animated}
                    camera-orbit={props.model.Orbit ? `${props.model.Orbit.theta}rad ${props.model.Orbit.phi}rad ${props.model.Orbit.radius}m` : '0deg 75deg 105%'}
                    style={{"--poster-color": '#303030'}}
                    enable-pan
                ></model-viewer>
            </Paper>
        </Grid>
    )
}